import React from "react";

// `mobileIndent`: below "lgl" only, gives the heading a bit more room from
// the left edge than the default px-6 (used where content below sits close
// enough to the edge that the heading reads as cramped). At "lgl" and up:
// unchanged, always px-6.
const Title = ({ title, subTitle, mobileIndent = false }) => {
  return (
    <h1
      className={`font-titleFont font-bold text-xl capitalize text-textColor relative z-10 py-3 border-b-[1px] border-b-lineColor group break-words ${
        mobileIndent ? "pl-8 pr-6 lgl:px-6" : "px-6"
      }`}
    >
      <span className="text-designColor">{title}</span> {subTitle}
      <span className="w-8 h-8 bg-gradient-to-t from-designColor to-trackColor inline-block rounded-full absolute left-2 top-3 opacity-10 -z-10 translate-x-0 group-hover:translate-x-24 transition-transform duration-500"></span>
    </h1>
  );
};

export default Title;
